const sk = {
  questionPaperLibrary: "Knižnica testových podkladov",
  questionPaperLibraryDescription:
    "Vas dynamicky pracovny priestor na tvorbu jednotlivych otazok a navrhovanie komplexnych sad otazok.",
  assessmentLibrary: "Knižnica hodnoteni",
  assessmentLibraryDescription:
    "Spravujte harmonogramy, pozyvajte ucastnikov a sledujte vykonnostne reporty v jednom centralizovanom centre.",
  myAssessmentWidgetTitle: "Moje hodnotenie",
  myPreferences: "Moje preferencie",
  assessmentsForYou: "Hodnotenia pre vas",
  exploreAssessmentsAssignedToYou: "Preskumajte hodnotenia priradene vam",
  hitachiAcademy: "Hitachi akademia",
  essentialBusinessKnowledgeTestForYou:
    "Zakladny test obchodnych znalosti pre vas",
  continuousLearningJourneyDescription:
    "Navrhnute tak, aby vam pomohlo porozumiet a posilnit vase obchodne zrucnosti pocas nepretrziteho vzdelavania",
  noActiveAssessmentsScheduledForYou:
    "Pre vas nie su naplanovane ziadne aktivne hodnotenia",
  upcoming: "Nadchadzajuce",
  notAttempted: "Nepokusene",
  myAssessmentCardDescription:
    "Toto hodnotenie preveruje vase technicke, analyticke a schopnosti riesit problemy ako sucast kampusoveho naboroveho procesu GlobalLogic.",
  totalDuration: "Celkove trvanie",
  startTime: "Cas zaciatku",
  questionAuthoring: "Tvorba otazok",
  reviewQuestions: "Skontrolovat otazky",
  bulkUploadHistory: "Historia hromadneho nahravania",
  bulkActionHistory: "Historia hromadnych akcii",
  editQuestion: "Upravit otazku",
  inviteParticipants: "Pozvat ucastnikov",
  externalUserBulkUploadHistory:
    "Historia hromadneho nahravania externych pouzivatelov",
  assessmentSchedule: "Harmonogram hodnotenia",
  assessmentReport: "Sprava o hodnoteni",
  bulkHistory: "Hromadna historia",
  myUpload: "Moje nahravanie",
  bulkUpload: "Hromadne nahravanie",
  createQuestion: "Vytvorit otazku",
  bulkUploadQuestions: "Hromadne nahravanie otazok",
  filters: "Filtre",
  clear: "Vymazat",
  searchByTitle: "Hladat podla nazvu",
  refresh: "Obnovit",
  refreshing: "Obnovuje sa",
  reviewQuestionPapers: "Skontrolovat sady otazok",
  myQuestionPapers: "Moje sady otazok",
  viewQuestionBank: "Zobrazit banku otazok",
  createNew: "Vytvorit nove",
  sortBy: "Zoradit podla",
  state: "Stav",
  reviewed: "Skontrolovane",
  reviewedTooltip:
    "Zobrazi sady otazok, ktore boli skontrolovane a nasledne publikovane.",
  all: "Vsetko",
  draft: "Koncept",
  published: "Publikovane",
  inReview: "V kontrole",
  sentBack: "Vratene",
  readyToPublish: "Pripravene na publikovanie",
  draftDescription:
    "Tvorba sady otazok stale prebieha a este nie je dostupna pre ucastnikov",
  publishedDescription: "Sada otazok je aktivna a dostupna pre ucastnikov",
  inReviewDescription: "Sada otazok je v kontrole a este nie je schvalena",
  sentBackDescription: "Sada otazok bola vratena na upravy",
  readyToPublishDescription: "Sada otazok je pripravena na publikovanie",
  createdAt: "Vytvorene",
  updatedAt: "Aktualizovane",
  publishedAt: "Publikovane",
  descending: "Zostupne",
  ascending: "Vzostupne",
  success: "Úspech",
  error: "Chyba",
  warning: "Upozornenie",
  info: "Informácia",
  yes: "Ano",
  no: "Nie",
  noMatchingContentFound: "Nenasiel sa ziadny zodpovedajuci obsah",
  noQuestionPapersAvailableForReview:
    "Nie su k dispozicii ziadne sady otazok na kontrolu",
  questionPaperNotYetCreated: "Sada otazok este nebola vytvorena",
  createQuestionPaperDescription:
    "Vytvorte sadu otazok na vyhodnotenie zrucnosti a vedomosti ucastnikov",
  createYourFirstQuestionPaper: "Vytvorte svoju prvu sadu otazok",
  createQuestionPaperModalTitle: "Vytvorit sadu otazok",
  questionsTab: "Otázky",
  questionPaperSettingsTab: "Nastavenia papiera s otázkami",
  editQuestionPaper: "Upraviť dotazník",
  save: "Uložiť",
  publish: "Publikovať",
  sendForReview: "Odoslať na kontrolu",
  sendingForReview: "Odosielanie na kontrolu",
  publishing: "Publikovanie",
  clone: "Klonovať",
  delete: "Odstrániť",
  view: "Zobraziť",
  edit: "Upraviť",
  close: "Zavrieť",
  create: "Vytvorte",
  creating: "Vytváranie",
  confirm: "Potvrďte",
  cancel: "Zrušiť",
  version: "Verzia",
  untitled: "Bez názvu",
  noVersion: "Žiadna verzia",
  title: "Názov",
  status: "Stav",
  action: "Akcia",
  createdBy: "Vytvoril",
  createNewVersion: "+ Nová verzia",
  createNewVersionTitle: "Vytvoriť novú verziu",
  deleteQuestionPaperPrompt: "Naozaj chcete odstrániť tento otáznik?",
  deleteQuestionPaperWithTitlePrompt:
    "Chcete odstrániť tento otáznik s názvom „{{title}}“?",
  cloneQuestionPaperPrompt: "Chcete naklonovať tento papier s otázkami?",
  publishQuestionPaperPrompt: "Naozaj chcete zverejniť tento dotazník?",
  sendForReviewQuestionPaperPrompt:
    "Naozaj chcete poslať tento dotazník na posúdenie?",
  successfullyDeletedQuestionPaper: "Papier s otázkami bol úspešne odstránený",
  successfullyMovedQuestionPaperToDraft:
    "Papier s otázkami bol úspešne presunutý do konceptu",
  successfullySavedQuestionPaperData: "Údaje z dotazníka boli úspešne uložené",
  successfullyClonedQuestionPaper: "Papier s otázkami bol úspešne naklonovaný",
  successfullyCreatedQuestionPaper: "Úspešne sa vytvoril papier s otázkami",
  validationFailedWithFollowingErrors:
    "Overenie zlyhalo s nasledujúcimi chybami:",
  failedStatusUpdateOf: "Neúspešná aktualizácia stavu :",
  savedWithFollowingWarnings: "Uložené s nasledujúcimi upozorneniami:",
  reviewedAndPublished: "Skontrolované a zverejnené",
  deleting: "Odstraňuje sa...",
  cloning: "Klonovanie...",
  assessment: "Hodnotenie",
  public: "Verejné",
  private: "Súkromné",
  visibility: "Viditeľnosť",
  questionType: "Typ otázky",
  selectQuestionTypeAndVisibility: "Vyberte typ otázky a viditeľnosť",
  singleChoice: "Jedna možnosť",
  multipleChoice: "Viacnásobná voľba",
  trueOrFalse: "Pravda alebo nepravda",
  fillInTheBlanks: "Vyplňte medzery",
  codingQuestion: "Kódovacia otázka",
  subjectiveQuestion: "Subjektívna otázka",
  speakingQuestion: "Hovoriaca otázka",
  downloadTemplateEditAndReuploadQuestions:
    "Stiahnite si šablónu, upravte a znova nahrajte zoznam otázok",
  downloadExcelTemplateInstruction:
    "Stiahnite si excelovú šablónu pomocou tlačidla nižšie.",
  addQuestionsToSheetInstruction:
    "Pridajte svoje otázky do hárku (pokyny sú súčasťou).",
  uploadCompletedExcelInstruction:
    "Nahrajte vyplnený súbor Excel na hromadný import otázok.",
  uploading: "Nahráva sa...",
  uploadQuestions: "Nahrať otázky",
  completed: "Dokončené",
  invalid: "Neplatné",
  initiated: "Iniciované",
  failed: "Nepodarilo sa",
  fileName: "Názov súboru",
  templateType: "Typ šablóny",
  uploadedAt: "Odovzdané o",
  actions: "Akcie",
  mcqTemplate: "Šablóna MCQ",
  fibTemplate: "FIB šablóna",
  monitorUploadExcelDescription:
    "Monitorujte každý nahraný súbor Excel, skontrolujte, koľko otázok bolo pridaných alebo zlyhaných, a v prípade potreby si pozrite podrobnosti o chybe.",
  reset: "Resetovať",
  showing: "Zobrazuje sa",
  to: "do",
  of: "z",
  results: "výsledky",
  noExcelFound: "Nebol nájdený žiadny Excel",
  cloneAssessmentConfirmation: "Potvrdenie klonovania",
  cloneAssessmentWithTitlePrompt:
    "Naozaj chcete naklonovať toto hodnotenie s názvom „{{title}}“?",
  successfullyClonedAssessment: "Hodnotenie bolo úspešne naklonované",
  newVersionContentPrompt:
    "Chystáte sa vytvoriť novú verziu tohto obsahu. Všetky ďalšie zmeny sa uložia do tejto verzie. Chcete pokračovať?",
  createVersionWithNumber: "Vytvoriť (V{{version}})",
  addYourComment: "Pridajte svoj komentár",
  maxLimitReached: "maximálny limit dosiahnutý",
  deleteContentPrompt: "Naozaj chcete odstrániť toto {{contentType}}?",
  deleteContentWithTitlePrompt:
    "Naozaj chcete odstrániť toto {{contentType}} s názvom „{{title}}“?",
  schedulePreview: "Ukážka plánu",
  reschedule: "Preplánovať",
  cancelled: "Zrušené",
  copyLink: "Kopírovať odkaz",
  assessmentIsCancelled: "Hodnotenie sa ruší",
  deleteConfirmation: "Vymazať potvrdenie",
  cancelConfirmation: "Zrušiť potvrdenie",
  deleteAssessmentPrompt: "Naozaj chcete odstrániť toto hodnotenie?",
  cancelAssessmentPrompt: "Naozaj chcete zrušiť toto hodnotenie?",
  rescheduleAssessment: "Preplánovať hodnotenie",
  customTermsAndConditions: "Vlastné zmluvné podmienky",
  viewTermsAndConditions: "Zobraziť T&C",
  scheduleNewAssessment: "Naplánujte nové hodnotenie",
  selectQuestionPaper: "Vyberte Otáznik",
  createAssessment: "Vytvoriť hodnotenie",
  failedToLoadData: "Údaje sa nepodarilo načítať!",
  assessmentNotYetCreated: "Hodnotenie ešte nebolo vytvorené",
  createAssessmentDescription:
    "Vytvorte hodnotenie na vyhodnotenie zručností a vedomostí študentov",
  createYourFirstAssessment: "Vytvorte si prvé hodnotenie",
  failedToLoadSchedules: "Nepodarilo sa načítať plány",
  errors: "Chyby:",
  basicInformation: "Základné informácie",
  assessmentName: "Názov hodnotenia",
  na: "NA",
  scheduleInstructions: "Pokyny k rozvrhu",
  noInstructionsProvided: "Nie sú poskytnuté žiadne pokyny",
  accessCriteria: "Kritériá prístupu",
  searchTags: "Hľadať značky",
  viewAttributes: "Zobraziť atribúty",
  termsAndConditions: "Zmluvné podmienky",
  enabled: "Povolené",
  disabled: "Zakázané",
  requireCandidatesToAcceptTerms:
    "Pred začatím hodnotenia požiadajte kandidátov, aby prijali T&C",
  proctoringSettings: "Nastavenia proktorovania",
  enableVideoProctoring: "Povoliť funkciu Video Proctoring",
  maximumVideoViolationsAllowed:
    "Maximálny povolený počet porušení pravidiel pre video",
  enableBrowserProctoring: "Povoliť ochranu prehliadača",
  maximumBrowserViolationsAllowed: "Maximálne povolené porušenia prehliadača",
  displayViolationsToCandidates: "Zobrazte priestupky kandidátom",
  actionWhenViolationLimitReached: "Akcia pri dosiahnutí limitu porušenia",
  flagged: "Označené",
  terminate: "Ukončiť",
  stakeholdersAndFeedback: "Zainteresované strany a spätná väzba",
  owner: "Vlastník",
  recruiter: "Náborový pracovník",
  allowCandidateFeedback: "Povoliť spätnú väzbu od kandidáta",
  enableCandidateFeedbackDescription:
    "Umožnite kandidátom odoslať spätnú väzbu po dokončení hodnotenia",
  schedulingAndTimerSettings: "Nastavenia plánovania a časovača",
  scheduleType: "Typ rozvrhu",
  loginWindow: "Prihlasovacie okno",
  durationBased: "Na základe trvania",
  deadline: "Termín",
  autoCompleteMode: "Režim automatického dokončovania",
  startDateAndTime: "Dátum a čas začiatku",
  loginWindowInMinutes: "Prihlasovacie okno (v minútach)",
  endDateAndTime: "Dátum a čas ukončenia",
  timerEnabled: "Časovač zapnutý",
  assessmentRules: "Pravidlá hodnotenia",
  assessmentPattern: "Vzor hodnotenia",
  resultVisibility: "Viditeľnosť výsledku",
  passPercentage: "Percento prechodu",
  maximumAttemptsAllowed: "Maximálny povolený počet pokusov",
  unlimitedAttempts: "Neobmedzené pokusy",
  attempt: "pokus",
  attempts: "pokusov",
  coolOffPeriodBetweenAttempts: "Obdobie vychladnutia medzi pokusmi",
  questionDisplaySettings: "Otázka Nastavenia zobrazenia",
  showQuestionTitle: "Zobraziť názov otázky",
  showQuestionTitleDescription: "Nad každou otázkou zobrazte názov otázky",
  showHint: "Zobraziť nápovedu",
  hintLoading: "Musíte počkať, kým neuvidíte ďalší tip",
  allHintsShown: "Žiadne tipy nie sú čakajúce",
  showHintDescription:
    "Povoliť tipy, ktoré pomôžu kandidátovi počas hodnotenia",
  showExplanation: "Zobraziť vysvetlenie",
  hideExplanation: "Skryť vysvetlenie",
  showExplanationDescription: "Po každom odoslaní otázky zobraziť vysvetlenia",
  showQuestionMarks: "Zobraziť otázniky",
  showQuestionMarksDescription: "Zobrazte hodnotu známky/bodu pre každú otázku",
  showWatermark: "Zobraziť vodoznak",
  showWatermarkDescription:
    "Zobrazte e-mailovú adresu kandidáta pre každú otázku ako vodotlač",
  questionPaperPreview: "Náhľad papiera s otázkami",
  questionPaperReview: "Preskúmanie dotazníka",
  createSchedule: "Vytvoriť plán",
  reviewerComments: "Komentáre recenzenta",
  reviewComments: "Kontrola komentárov",
  sendBackQuestionPaperPrompt: "Naozaj chcete poslať tento dotazník späť?",
  moveQuestionPaperToDraftPrompt:
    "Naozaj chcete presunúť tento otáznik do konceptu?",
  markQuestionPaperReadyToPublishPrompt:
    "Naozaj chcete tento otáznik označiť ako pripravený na zverejnenie?",
  questionPaperStatusUpdatedSuccessfully:
    "Stav dotazníka bol úspešne aktualizovaný!",
  newVersionQuestionPaperCreatedSuccessfully:
    "Nová verzia dotazníka bola úspešne vytvorená!",
  questionPaperClonedSuccessfully: "Papier s otázkami bol úspešne naklonovaný!",
  startAddingQuestionsPreview:
    "Začnite pridávať otázky, aby ste si ich mohli pozrieť tu",
  bulkInviteParticipants: "Hromadné pozvanie účastníkov",
  bulkInviteParticipantsDescription:
    "Pozvite viacerých účastníkov naraz odovzdaním vopred vyplneného súboru Excel. Na zabezpečenie správneho formátu použite poskytnutú šablónu.",
  maxParticipantsPerFileNote:
    "Maximálne 200 účastníkov na súbor. Duplicitné alebo neplatné záznamy budú preskočené s chybou.",
  downloadTemplate: "Stiahnite si šablónu",
  creatingUser: "Vytvára sa používateľ...",
  bulkInviteLabel: "Hromadné pozvanie",
  createAndInvite: "Vytvoriť a pozvať",
  myUploads: "Moje nahrané položky",
  enterIndividualsForInvite:
    "Zadajte mená jedného alebo viacerých jednotlivcov, ktorých chcete pozvať na test",
  searchPeopleByEmailOrName: "Hľadať osoby podľa e-mailu alebo mena",
  noResultsFound: "Nenašli sa žiadne výsledky",
  loading: "Načítava sa...",
  or: "Alebo",
  multipleEmailsInviteDescription:
    "Pridajte viacero e-mailov používateľov oddelených čiarkami, aby ste na test pozvali viacerých používateľov",
  addCandidates: "Pridať kandidátov",
  pleaseEnterValidNameOrEmail: "Zadajte platné meno alebo e-mailovú adresu",
  pleaseEnterValidEmailAddress: "Zadajte platnú e-mailovú adresu",
  someEmailsCouldNotBeAdded: "Niektoré e-mailové adresy sa nepodarilo pridať",
  checkInvalidEmailIds:
    "Skontrolujte nasledujúce e-mailové ID – zdá sa, že sú neplatné:",
  failedToSendInvitesFollowingEmails:
    "Nepodarilo sa odoslať pozvánky na nasledujúce e-maily:",
  successfullyInvitedMembers: "{{count}} člen bol úspešne pozvaný",
  validationFailed: "Overenie zlyhalo",
  excelUploadedSuccessfully: "Excel bol úspešne odovzdaný",
  invalidBulkNominationTemplate: "Neplatná šablóna hromadnej nominácie",
  actionCompletedWithWarnings:
    "Akcia bola dokončená s nasledujúcimi upozorneniami:",
  actionFailedWithErrors:
    "Akciu nebolo možné dokončiť a ukončiť s nasledujúcimi chybami:",
  trackBulkOperationsAndResults:
    "Sledujte všetky svoje hromadné operácie a ich výsledky",
  partiallySaved: "Čiastočne uložené",
  statusInitiatedDescription:
    "Žiadosť o aktualizáciu otázky bola odoslaná a spracováva sa.",
  statusCompletedDescription:
    "Všetky vybrané otázky boli úspešne aktualizované.",
  statusFailedDescription:
    "Žiadna z vybraných otázok nemohla byť úspešne spracovaná.",
  statusPartiallySavedDescription:
    "Niektoré otázky boli úspešne uložené, pri iných sa vyskytli problémy.",
  draftReadyToPublishToPublish:
    "Koncept/Pripravené na zverejnenie -> Zverejniť",
  actionType: "Typ akcie",
  uploadedOn: "Nahrané dňa",
  viewDetails: "Zobraziť podrobnosti",
  loadingRecords: "Načítavajú sa záznamy...",
  noRecordsFound: "Nenašli sa žiadne záznamy",
  recordsPerPage: "Záznamy na stránku:",
  page: "Stránka",
  untitledQuestion: "Otázka bez názvu",
  globalLogic: "GlobalLogic",
  aiGenerated: "Generovaná AI",
  fullScreen: "Celá obrazovka",
  exitFullScreen: "Ukončiť celú obrazovku",
  skills: "Zručnosti",
  tags: "Tagy",
  allowedCodingLanguages: "Povolené kódovacie jazyky",
  marks: "Body",
  lastUpdatedAt: "Naposledy aktualizované o",
  solutionCode: "Kód riešenia",
  solution: "Riešenie",
  starterCode: "Štartovací kód",
  options: "Možnosti",
  explanation: "Vysvetlenie",
  hint: "Nápoveda",
  deleteQuestion: "Odstrániť otázku",
  noSections: "Nepridali sa žiadne sekcie",
  editAndPublish: "Upraviť a zverejniť",
  sendBackToDraftInstruction:
    "Kliknutím na tlačidlo odoslať späť odošlete otázku späť do konceptu.",
  updateStatusReadyToPublishInstruction:
    "Kliknutím na tlačidlo Pripravené na zverejnenie aktualizujte stav.",
  successfullyUpdatedStatus: "Stav bol úspešne aktualizovaný",
  dismiss: "Odmietnuť",
  ongoing: "Prebieha",
  toBeLaunched: "Bude spustené",
  contentExpired: "Obsah vypršal",
  notApplicable: "Neuplatňuje sa",
  expiresSoon: "Čoskoro vyprší",
  contentCreationInProgressTooltip:
    "Tvorba obsahu stále prebieha a zatiaľ nie je dostupná pre študentov",
  contentLiveAccessibleTooltip: "Obsah je zverejnený a dostupný pre študentov",
  contentAvailableWithinDatesTooltip:
    "Obsah je momentálne dostupný, pretože je v rámci dátumu spustenia a vypršania",
  contentNotLaunchedAvailableOnTooltip:
    "Obsah ešte nebol spustený a bude dostupný",
  contentExpiredOnTooltip: "Tento obsah vypršal",
  statusAvailableAfterPublishTooltip: "Stav bude dostupný po zverejnení obsahu",
  contentExpiresWithin48HoursTooltip: "Obsah vyprší do 48 hodín.",
  moveToDraftOrCloneToEdit:
    "Presuňte ho do konceptu alebo ho klonujte na úpravy",
  webContent: "Webový obsah",
  eLearning: "E-learning",
  untitledContent: "Obsah bez názvu",
  sendToDraft: "Presunúť do konceptu",
  sendToDraftPublishedInstruction:
    "Tento obsah je už zverejnený. Ak chcete vykonať zmeny, kliknite na tlačidlo Presunúť do konceptu.",
  copyLinkForLearner: "Kopírovať odkaz pre študenta",
  questionPaperName: "Názov sady otázok",
  type: "Typ",
  duration: "Trvanie",
  minutes: "Minúty",
  difficultyLevel: "Úroveň obtiažnosti",
  language: "Jazyk",
  timezone: "Časové pásmo",
  preferredLocation: "Preferovaná lokalita",
  notSelected: "Nevybrané",
  selectedPreferencesHeading: "Vybrané preferencie",
  selectedPreferencesInfo: "Vybrané preferencie pre plynulejší zážitok",
  shortDescription: "Krátky popis",
  totalMarks: "Celkový počet bodov",
  questionPaperInstructions: "Pokyny k sade otázok",
  expiryDate: "Dátum vypršania",
  knowledgeCategory: "Kategória znalostí",
  category: "Kategória",
  subCategory: "Podkategória",
  region: "Región",
  usage: "Použitie",
  internalUseOnly: "Len na interne pouzitie",
  externalUseOnly: "Len na externe pouzitie",
  availableForAll: "Dostupne pre vsetkych",
  apac: "APAC",
  emea: "EMEA",
  latinAmerica: "Latinská Amerika",
  northAmerica: "Severná Amerika",
  globalRegion: "Globálne",
  automotive: "Automobilový priemysel",
  bankingFinancialServicesInsurance:
    "Bankovníctvo, finančné služby a poisťovníctvo",
  connectivitySolutionsCommunication: "Riešenia pripojenia/komunikácie",
  consumerRetail: "Spotrebiteľský a maloobchodný sektor",
  healthcareLifeSciences: "Zdravotníctvo a biologické vedy",
  manufacturingAndIndustrial: "Výroba a priemysel",
  mediaEntertainment: "Médiá a zábava",
  technology: "Technológia",
  other: "Iné",
  behavioralInterpersonal: "Behaviorálne/interpersonálne",
  technical: "Technické",
  processAndTools: "Procesy a nástroje",
  polishLanguage: "Poľština",
  spanishLanguage: "Španielčina",
  japaneseLanguage: "Japončina",
  germanLanguage: "Nemčina",
  ukrainianLanguage: "Ukrajinčina",
  swedishLanguage: "Švédčina",
  romanianLanguage: "Rumunčina",
  slovakLanguage: "Slovenčina",
  croatianLanguage: "Chorvátčina",
  englishUsLanguage: "Angličtina (US)",
  englishUkLanguage: "Angličtina (UK)",
  englishInLanguage: "Angličtina (IN)",
  netTech: "NET",
  aiMl: "AI/ML",
  automotiveStandardsProtocols: "Automobilové štandardy a protokoly",
  businessAnalysis: "Business analýza",
  cCpp: "C/C++",
  cloudDataScience: "Cloud data science",
  bigData: "Big Data",
  dataAnalytics: "Dátová analytika",
  databaseTech: "Databáza",
  developmentTools: "Vývojové nástroje",
  devops: "DevOps",
  embedded: "Embedded",
  javaTech: "Java",
  javaScriptTech: "JavaScript",
  linuxKernel: "Linux kernel",
  mobileDev: "Mobilný vývoj",
  networking: "Sieťovanie",
  operatingSystemsServers: "Operačné systémy a servery",
  otherTech: "Iné - Tech",
  productivityTools: "Nástroje produktivity",
  programmingLangOther: "Programovací jazyk - Iné",
  pythonTech: "Python",
  phpTech: "PHP",
  qaAqa: "QA / AQA",
  softwareEngineering: "Softvérové inžinierstvo",
  uxUi: "UX/UI",
  architectureTech: "Architektúra",
  golang: "Golang",
  requirementEngineeringTechnicalWriting:
    "Požiadavkové inžinierstvo/Technické písanie",
  onboarding: "Onboarding",
  glTools: "GL nástroje",
  processAndPolicies: "Procesy a politiky",
  communicationSubCategory: "Komunikácia",
  personalEffectiveness: "Osobná efektivita",
  methodologies: "Metodiky",
  projectManagement: "Projektové riadenie",
  peopleManagement: "Riadenie ľudí",
  leadershipPrograms: "Líderské programy",
  domain: "Doména",
  reviewer: "Recenzent",
  none: "Žiadny",
  questionPaperPreviewBreadcrumb: "Náhľad sady otázok: {{title}}",
  questionPaperInReviewContactReviewer:
    "Táto sada otázok je momentálne v recenzii. Kontaktujte recenzenta.",
  randomization: "Randomizácia",
  randomizationInSectionDescription:
    "Otazky v tejto sekcii sa kandidatom zobrazia v nahodnom poradi",
  questionPreviewPlaceholderImage: "Zástupný symbol náhľadu otázky",
  createNewVersionPromptWithNumber: "Vytvoriť novú verziu (V{{version}})?",
  questionPreviewBreadcrumb: "Nahlad otazky: {{title}}",
  questionPreviewTitle: "Nahlad otazky",
  adminView: "Administratorske zobrazenie",
  candidateView: "Zobrazenie kandidata",
  viewAsCandidate: "Zobrazit ako kandidat",
  closePanel: "Zavriet panel",
  internalQuestion: "Interna otazka",
  expiresOn: "Platnost do",
  expiredLabel: "Expirovane",
  solutionNotAdded: "Riesenie nebolo pridane",
  testCases: "Testovacie pripady",
  testCasesNotAdded: "Testovacie pripady neboli pridane",
  starterCodeNotAdded: "Uvodny kod nebol pridany",
  groupTitleLengthValidation:
    "Nazov skupiny musi mat viac ako 5 a menej ako 120 znakov",
  addTitleHere: "Pridajte nazov sem...",
  groupUpdatedSuccessfully: "Skupina bola uspesne aktualizovana",
  groupDeletedSuccessfully: "Skupina bola uspesne odstranena",
  group: "Skupina",
  numberOfQuestionsToBeShown: "Pocet otazok na zobrazenie",
  questionLimitPerSectionDescription:
    "Zobrazte kandidatom v sekciach iba urcity pocet otazok",
  numberOfQuestionsToShow: "Pocet otazok na zobrazenie {{picked}}/{{total}}",
  collapseGroup: "Zbalit skupinu",
  expandGroup: "Rozbalit skupinu",
  groupSetupStartAddingQuestions:
    "Pre tuto sekciu je nastavena skupina. Zacnite do nej pridavat otazky.",
  addMoreQuestions: "Pridat viac otazok",
  addQuestionFromLibrary: "Pridat otazku z kniznice",
  questionDeletedSuccessfully: "Otazka bola uspesne odstranena",
  questionsShownCountUpdated: "Pocet zobrazenych otazok bol aktualizovany",
  failedToDeleteQuestion: "Nepodarilo sa odstranit otazku",
  caseSensitive: "Rozlisuje velke a male pismena",
  caseSensitiveDescription:
    "Ak je povolene, studenti musia zadat odpoved s presne rovnakymi velkymi a malymi pismenami.",
  enterYourAnswerBelow: "Zadajte svoju odpoved nizsie",
  caseSensitiveAnswerInfo:
    "Tato otazka rozlisuje velke a male pismena, preto zadajte odpovede s presne rovnakou velkostou pismen.",
  answerWithNumber: "Odpoved {{number}}",
  inviteEmailsPlaceholder: "user1@globallogic.com,user2@globallogic.com",
  visibleTestCases: "Viditelne testovacie pripady",
  hiddenTestCases: "Skryte testovacie pripady",
  visibleLabel: "Viditelne",
  hiddenLabel: "Skryte",
  responseSetting: "Nastavenia odpovede",
  recordingLimit: "Limit nahravania",
  minimumResponseDuration: "Minimalna dlzka odpovede",
  uploadLimit: "Limit nahravania",
  practiceAllowed: "Cvicenie povolene",
  standardEvaluationRubricInfo:
    "Toto je standardna hodnotiaca rubrika, ktora sa pouzije na posudenie odpovede kandidata na tuto otazku.",
  criteria: "Kriteria",
  weightPercentage: "Vaha(%)",
  viewRemarks: "Zobraziť poznámky",
  input: "Vstup",
  expectedOutput: "Očakávané výstup",
  actualOutput: "Skutočný výstup",
  untitledSection: "Nepomenovaná sekcia",
  testSectionDescription: "Popis testovacej sekcie",
  groupAddedSuccessfully: "Skupina bola úspešne pridaná",
  addGroupToSection: "Pridať skupinu do sekcie",
  deleteSection: "Odstrániť sekciu",
  questionPaperDetails: "Podrobnosti o dokumente s otázkami",
  skillsInfoMessage:
    "Zoznam zásadných zručností, ktoré má tento dokument s otázkami hodnotiť.",
  contentSettings: "Nastavenia obsahu",
  stakeholderAndReview: "Zainteresovaní subjekty a prehľad",
  statusType: "Typ stavu",
  notReviewed: "Nerecenzované",
  sourceType: "Typ zdroja",
  proficiency: "Odbornosť",
  beginner: "začiatočník",
  intermediate: "Stredne pokročilý",
  advanced: "Pokročilé",
  wecp: "WECP",
  enterMarks: "Zadajte značky",
  removeSkill: "Odstráňte zručnosť",
  searchSkills: "Vyhľadávacie zručnosti",
  noSkillsFound: "Nenašli sa žiadne zručnosti.",
  enterTag: "Zadajte značku",
  enterOwner: "Zadajte vlastníka",
  enterReviewer: "Zadajte recenzenta",
  noUserWithRole: "Nenašiel sa žiadny používateľ s touto úlohou",
  createSection: "Vytvoriť sekciu",
  untitledGroup: "Skupina bez názvu",
  createGroup: "Vytvoriť skupinu",
  collapseSections: "Zbaliť sekcie",
  expandSections: "Rozbaliť sekcie",
  assessmentNamePlaceholder: "Zadajte názov hodnotenia",
  questionPaperTitleInfo: "Zadajte jasný a popisný názov dokumentu s otázkami.",
  shortDescriptionPlaceholder: "Poskytnite krátky popis",
  shortDescriptionInfo:
    "Krátke zhrnutie vysvetľujúce, čo obsahuje papier s otázkami.",
  questionPaperInstructionsInfo:
    "Pred začatím písania otázok napíšte pokyny, ktoré kandidáti uvidia. Zahrňte dôležité podrobnosti, ako sú pravidlá sekcií, formáty otázok, navigačné tipy a pokyny na odosielanie.",
  questionPaperInstructionsPlaceholder:
    "Pred začatím hodnotenia pridajte všetky dôležité pokyny pre študentov – trvanie, kritériá na absolvovanie, povolené nástroje alebo pokyny.",
  totalMarksAutoCalculatedInfo:
    "Celkové známky sa automaticky vypočítajú na základe počtu otázok vybraných pre každú skupinu. Ak je počet zobrazených otázok nastavený na 0, táto skupina bude vylúčená z celkového počtu bodov.",
  questionPaperType: "Typ papiera s otázkami",
  questionPaperTypeInfo: "Vyberte formát papiera s otázkami.",
  durationInfo:
    "Nastavte celkový časový limit na vyplnenie úlohy (v minútach).",
  difficultyLevelInfo:
    "Vyberte očakávanú úroveň obtiažnosti na základe skúseností kandidáta.",
  languageInfo: "Vyberte jazyk, v ktorom sa bude prezentovať otázka.",
  tagsInfo:
    "Pridajte kľúčové slová, aby ste pomohli ostatným nájsť tento dotazník pomocou vyhľadávania.",
  selectCategory: "Vyberte kategóriu",
  createLevel: "Vytvorte",
  evaluate: "Vyhodnotiť",
  analyze: "Analyzovať",
  apply: "Použiť",
  understand: "Pochopte",
  remember: "Pamätajte",
  allowedCodingLanguagesRequiredInfo:
    "pole je povinné len vtedy, keď do dotazníka pridávate kódovacie otázky.",
  knowledgeCategoryInfo:
    "Vyberte úroveň kognitívnych zručností, na ktorú sa zameriava táto otázka, napr.",
  allowedCodingLanguagesInfo:
    "Vyberte programovacie jazyky povolené pre kódovanie otázok v tomto dotazníku.",
  expiryDateInfo:
    "Nastavte voliteľný dátum, po ktorom by sa tento otáznik už nemal používať.",
  visibilityInfo: "Vyberte viditeľnosť papiera s otázkami",
  visibilityLockedInfo:
    "Po zverejnení dokumentu s otázkami s viditeľnosťou pre verejnosť budú všetky jeho ostatné verzie tiež viditeľné pre verejnosť. Podobne, ak je zverejnená ako súkromná, všetky verzie zostanú súkromné.",
  reviewRequired: "Vyžaduje sa recenzia",
  reviewRequiredLockedInfo:
    "Nastavenie „Review Required“ je synchronizované vo všetkých verziách dotazníka. Ak je niektorá verzia publikovaná s povolenou alebo zakázanou recenziou, rovnaké nastavenie bude platiť pre všetky verzie a nemožno ich upravovať jednotlivo.",
  reviewRequiredInfo:
    "Povoľte, ak tento dotazník musí pred zverejnením prejsť formálnym procesom kontroly.",
  savingData: "Ukladajú sa údaje...",
  questionDataSavedSuccessfully: "Údaje otázky boli úspešne uložené",
  sendQuestionForReviewInstruction:
    "Kliknutím na tlačidlo Odoslať na recenziu ho odošlete recenzentovi, aby ho skontroloval!",
  publishQuestionInstruction:
    "Kliknutím na tlačidlo publikovať otázku zverejníte.",
  noLearningContentAddedAfterSelectingYes:
    "Po výbere Áno sa nepridá žiadny vzdelávací obsah",
  expectedTimeInMinutes: "Predpokladaný čas (v min)",
  codingMarksAutoCalculatedInfo:
    "Tieto známky sa vypočítavajú automaticky na základe skrytých testovacích prípadov pridaných k tejto otázke",
  skillsInfoMessageQuestion:
    "Poskytnite špecifické zručnosti, ktoré účastníci získajú z otázky",
  skillsSubtitleQuestion: "Nastavte zručnosti spojené s touto otázkou",
  allowedCodingLanguagesInfoQuestion:
    "Vyberte jazyky dostupné na vyriešenie tejto otázky",
  selectCodingLanguages: "Vyberte kódovacie jazyky",
  allLanguages: "Všetky jazyky",
  tagsInfoQuestion:
    "Poskytnite kľúčové slová na kategorizáciu, popis a identifikáciu udalosti",
  tagsSubtitleQuestion: "Nastavte značky pre rýchle vyhľadávanie",
  knowledgeCategorySubtitleQuestion:
    "Pomáha kategorizovať otázky podľa úrovne kognitívnych schopností.",
  explanationNotAvailableForSpeakingQuestion:
    "Pre Speaking Question nie je k dispozícii vysvetlenie",
  ownerVersionSyncInfo:
    "Ak zmeníme vlastníka tejto verzie, aktualizuje sa aj vo všetkých vytvorených verziách.",
  ownerInfoMessage: "Vyberte primárneho vlastníka (vlastníkov) otázky",
  ownerReviewerCannotBeSame: "vlastník a recenzent nemôžu byť rovnakí",
  reviewerInfoMessage:
    "Vyberte jednotlivca alebo skupinu jednotlivcov ako recenzentov",
  stakeholdersUpdatedSuccessfully:
    "Zainteresované strany boli úspešne aktualizované!",
  unexpectedErrorCreatingNewVersion:
    "Pri vytváraní novej verzie sa vyskytla neočakávaná chyba.",
  previewAndPublish: "Ukážka a zverejnenie",
  viewAnalytics: "Zobraziť službu Analytics",
  cloneQuestionPrompt: "Chcete naklonovať túto otázku?",
  evaluationRubric: "Hodnotiaca rubrika",
  problemStatement: "Vyhlásenie o probléme",
  problemStatementPlaceholder:
    "Zadajte vyhlásenie o probléme alebo vyhlásenie pre kvíz",
  addOptionsAndMarkCorrectAnswer: "Pridajte možnosti a označte správnu odpoveď",
  markCorrectAnswer: "Označte správnu odpoveď",
  addCorrectAnswer: "Pridajte správnu odpoveď",
  enterCorrectAnswerForBlank: "Zadajte správnu odpoveď na prázdne {{číslo}}",
  blankWithNumber: "Prázdne {{number}}",
  addProblemStatementWithBlankToEnableAnswer:
    "Ak chcete povoliť odpoveď, pridajte správne vyhlásenie o probléme s „&prázdnym“.",
  enterSolution: "Zadajte riešenie",
  enterExplanation: "Zadajte vysvetlenie",
  codingSolutionExplanationPlaceholder:
    "Stručne vysvetlite logiku, prístup a okrajové prípady spracované v optimálnom riešení",
  optionWithNumber: "Možnosť {{number}}",
  enterExplanationForAnswer: "Zadajte vysvetlenie odpovede {{number}}",
  addOptionToEnableExplanation:
    "Ak chcete povoliť vysvetlenie, pridajte možnosť {{číslo}}.",
  enterExplanationForBlank: "Zadajte vysvetlenie pre prázdne {{číslo}}",
  addProblemStatementWithBlankToEnableExplanation:
    "Pridajte správne vyhlásenie o probléme s '&prázdnym', aby ste umožnili vysvetlenie.",
  enterHint: "Zadajte nápovedu",
  addUpTo3Hints: "Pridajte až 3 rady",
  addMoreOptions: "Pridajte ďalšie možnosti",
  answer: "Odpoveď",
  exitCodeBlockInfo:
    'Ak chcete ukončiť blok kódu, prejdite na koniec riadku a trikrát kliknite na "Enter".',
  fibBlankInsertionInfo:
    'Ak chcete pridať medzeru, vyberte text a kliknite na tlačidlo "Vložiť prázdne miesto" alebo ručne pridajte &blankN, kde N môže byť akékoľvek celé číslo, napr.: &blank1;',
  htmlEditorAccessInfo:
    "Ak chcete pridať kód alebo mať kontrolu nad formátom, môžete vstúpiť do editora HTML kliknutím na ikonu úprav",
  skillSelectionCannotBeEmpty: "Výber zručností nemôže byť prázdny",
  maxDurationInfo:
    "Maximálny čas, ktorý má používateľ na zaznamenanie svojej odpovede na túto otázku.",
  minDurationInfo:
    "Minimálny požadovaný čas nahrávania, ktorý musí používateľ dokončiť pred odoslaním odpovede.",
  uploadLimitInfo:
    "Koľkokrát môže používateľ znova nahrať svoju odpoveď pred konečným odoslaním.",
  textQuestionTitle: "Toto je textová otázka",
  audioRecordQuestionTitle: "Toto je otázka na zvukový záznam",
  audioUploadQuestionTitle: "Toto je otázka na nahrávanie zvuku",
  videoRecordQuestionTitle: "Toto je otázka týkajúca sa videozáznamu",
  videoUploadQuestionTitle: "Toto je otázka nahrávania videa",
  subjectiveQuestionUploadConfigTitle: "Subjektívna otázka Upload Config Title",
  recordingLimitInMinutes: "Limit nahrávania (v minútach)",
  minimumResponseDurationInMinutes: "Minimálne trvanie odpovede (v min)",
  recordingLimitLessThanTwenty: "Limit nahrávania musí byť menší ako 20",
  recordingLimitGreaterThanOrEqualOne:
    "Limit záznamu musí byť väčší alebo rovný 1",
  minimumDurationLessThanRecordingLimit:
    "Minimálne trvanie odozvy musí byť kratšie ako limit záznamu",
  durationGreaterThanPointFive: "Trvanie musí byť väčšie ako 0,5",
  uploadLimitGreaterThanZero: "Limit nahrávania musí byť väčší ako 0",
  addFieldSelectCodingLanguagesInfo:
    "Ak chcete pridať {{fieldLabel}}, najskôr vyberte povolené kódovacie jazyky v sekcii '{{basicDetails}}'.",
  basicDetails: "Základné detaily",
  loadingEditor: "Načítava sa editor...",
  run: "Spustiť",
  writingSolutionInLanguage: "Momentálne píšete riešenie",
  changingToLanguageWillClearInput: "Zmena na",
  unsavedChangesWillBeLostInLanguage: "Vaše neuložené zmeny v",
  changeLanguage: "Zmeniť jazyk",
  testCase: "Testovací prípad",
  add: "Pridať",
  addMinimumVisibleAndHiddenTestCasesInfo:
    "Nižšie pridajte minimálne 2 viditeľné testovacie prípady a 3 skryté testovacie prípady",
  visibleToCandidatesForSelfEvaluation:
    "Viditeľné pre kandidátov na sebahodnotenie",
  noVisibleTestCasesAddedYet:
    "Zatiaľ neboli pridané žiadne viditeľné testovacie prípady. Kliknutím na tlačidlo nižšie ho pridáte.",
  visibleTestCasesCannotExceedTwenty:
    "Viditeľných testovacích prípadov nemôže byť viac ako 20",
  addMoreVisibleTestCases: "Pridajte viditeľnejšie testovacie prípady",
  maximumTestCasesLimitReached:
    "Bol dosiahnutý maximálny limit testovacích prípadov",
  hiddenToCandidatesRunsAfterSubmit:
    "Skryté pre kandidátov, beží po odoslaní kandidáta",
  noHiddenTestCasesAddedYet:
    "Zatiaľ neboli pridané žiadne skryté testovacie prípady. Kliknutím na tlačidlo nižšie ho pridáte.",
  hiddenTestCasesCannotExceedTen:
    "Skrytých testovacích prípadov nemôže byť viac ako 10",
  addMoreHiddenTestCases: "Pridajte ďalšie skryté testovacie prípady",
  hiddenTestCase: "Skrytý testovací prípad",
  visibleTestCase: "Viditeľný testovací prípad",
  someQuestionsCouldNotBeUpdated:
    "Niektoré otázky nebolo možné aktualizovať. Skontrolujte si otázky a skúste to znova.",
  publishSummary: "Publikovať súhrn",
  sendForReviewSummary: "Odoslať na zhrnutie recenzie",
  moveToDraftSummary: "Presunúť do súhrnu konceptu",
  actionSummary: "Zhrnutie akcie",
  publishSummarySubtitle:
    "Tu je súhrn vašej akcie zverejnenia. Pozrite si podrobnosti nižšie.",
  sendForReviewSummarySubtitle:
    "Tu je súhrn vašej žiadosti o kontrolu. Pozrite si podrobnosti nižšie.",
  moveToDraftSummarySubtitle:
    "Tu je súhrn vášho prechodu na koncept akcie. Pozrite si podrobnosti nižšie.",
  actionSummarySubtitle:
    "Tu je súhrn vašej akcie. Pozrite si podrobnosti nižšie.",
  successfully: "Úspešne",
  failedTo: "Nepodarilo sa",
  moveToDraft: "Presunúť do konceptu",
  details: "Podrobnosti",
  questionTitle: "Názov otázky",
  reason: "Dôvod",
  showLess: "Ukážte menej",
  showMoreCount: "Zobraziť ďalšie ({{count}}).",
  uploadedAllCountItems: "Odovzdané všetky {{count}} {{item}}",
  partiallyUploadedCountItems:
    "Čiastočne nahrané {{successCount}}/{{totalCount}} {{item}}",
  users: "používateľov",
  questions: "otázky",
  viewErrors: "Zobraziť chyby",
  errorsWithFileName: "Chyby – {{fileName}}",
  inputIsRequired: "Vyžaduje sa vstup",
  expectedOutputIsRequired: "Vyžaduje sa očakávaný výstup",
  expectedOutputCannotBeBlank:
    "Očakávaný výstup nesmie byť prázdny alebo len medzery",
  marksMustBeNumber: "Známky by mali byť číslo",
  marksAreRequired: "Známky sú povinné",
  hiddenTestCaseMarksGreaterThanZero:
    "Ak chcete pokračovať, známky pre skryté testovacie prípady by mali byť väčšie ako 0.",
  hiddenTestCaseMarksMaxThirtyThousand:
    "Známky za skryté testovacie prípady by nemali presiahnuť 30 000.",
  explanationMinFiveIfProvided:
    "Vysvetlenie musí mať aspoň 5 znakov, ak je poskytnuté",
  explanationIsRequired: "Vyžaduje sa vysvetlenie",
  explanationMinFiveNotBlank:
    "Vysvetlenie musí mať aspoň 5 znakov a nie iba medzery",
  provideInput: "Poskytnite vstup",
  provideExpectedOutput: "Poskytnite očakávaný výstup",
  enterScore: "Zadajte skóre",
  optional: "voliteľné",
  explainTestCase: "Vysvetlite testovací prípad",
  updateTestCase: "Aktualizovať testovací prípad",
  addTestCase: "Pridať testovací prípad",
  deleteQuestionWithTitlePrompt:
    "Naozaj chcete odstrániť túto otázku s názvom '{{title}}'?",
  errorFetchingData: "Chyba pri načítavaní údajov",
  rowNumber: "Číslo riadku",
  columnName: "Názov stĺpca",
  useCase: "Prípad použitia",
  startsAt: "Začína o",
  endsAt: "Končí o",
  invite: "Pozvať",
  viewReport: "Zobraziť správu",
  successfullyDeletedAssessment: "Hodnotenie bolo úspešne odstránené",
  successfullyFreezeActionAssessment: "Úspešne {{action}} hodnotenie",
  freezeOperationFailed: "Operácia zmrazenia zlyhala",
  deleteAssessmentWithTitlePrompt:
    "Naozaj chcete odstrániť toto hodnotenie s názvom „{{title}}“?",
  freeze: "Zmraziť",
  unfreeze: "Rozmraziť",
  freezeAssessmentPrompt: "Naozaj chcete {{action}} toto hodnotenie?",
  expiresAt: "Platnosť vyprší o",
  seePreview: "Pozrite si ukážku",
  schedule: "Rozvrh",
  skillBenchmarking: "Porovnávanie zručností",
  skillBenchmarkingOverview:
    "Prehľad odbornosti účastníka v konkrétnych zručnostiach.",
  proctoringAnalysis: "Proctoringová analýza",
  proctoringAnalysisOverview:
    "Rýchly prehľad aspektov posudzovania súvisiacich s proporciou.",
  proctoringStatus: "Stav proktorovania",
  noIrregularitiesReported: "Neboli hlásené žiadne nezrovnalosti.",
  monitoringOverview: "Prehľad monitorovania",
  complianceNoIncidents:
    "Dodržiavanie pravidiel hodnotenia; žiadne incidenty alebo označené správanie.",
  viewEvidenceClicked: "Kliknutý dôkaz!",
  marksObtained: "Získané známky",
  correctAnswer: "Správna odpoveď",
  wrongAnswer: "Nesprávna odpoveď",
  sectionWiseAnalysis: "Analýza po častiach",
  sectionWiseAnalysisOverview: "Prehľad každej otázky a odpoveď kandidáta.",
  openAllSections: "Otvorte všetky sekcie",
  closeAllSections: "Zatvorte všetky sekcie",
  sectionWithNumber: "Sekcia {{number}}:",
  score: "skóre",
  questionAnalysis: "Analýza otázok",
  questionTitleFallback: "Názov otázky",
  candidateAnswer: "Kandidát odpoveď",
  loadAllQuestions: "Načítať všetky {{count}} {{item}}",
  attemptWithNumber: "Pokus č. {{number}}",
  invalidReportUrl: "Neplatná adresa URL prehľadu",
  failedToDownloadReportTryAgainLater:
    "Sťahovanie prehľadu zlyhalo. Skúste to znova neskôr!",
  downloadReport: "Stiahnite si správu",
  participantName: "Meno účastníka",
  dateOfAttempt: "Dátum pokusu",
  fail: "Zlyhanie",
  pass: "Úspech",
  userScoredInAssessment: "{{name}} dosiahol skóre {{percentage}} v hodnotení.",
  overallSummary: "Celkové zhrnutie",
  sectionAnalytics: "Sekcia Analytika",
  allAttempts: "Všetky pokusy",
  bestAttempt: "Najlepší pokus",
  latestAttempt: "Najnovší pokus",
  participantList: "Zoznam účastníkov",
  totalParticipantsInvited: "Celkový počet pozvaných účastníkov",
  notStarted: "Nespustené",
  inProgress: "Prebieha",
  resultsInProgress: "Výsledky prebiehajú",
  searchByNameOrEmail: "Hľadajte podľa mena alebo e-mailu",
  noUsersAvailableReportCannotBeGenerated:
    "Nie sú k dispozícii žiadni používatelia – prehľad nie je možné vygenerovať.",
  userName: "Používateľské meno",
  totalAttempt: "Celkový pokus",
  percentage: "Percento (%)",
  attemptTimeline: "Časová os pokusu",
  noDataFound: "Nenašli sa žiadne údaje",
  outOfMarks: "{{obtained}} z {{max}} značiek",
  resultInProcess: "Výsledok v procese",
  participantNotFound: "Účastník nebol nájdený!",
  searchedParticipantNotFound: "Hľadaný účastník nebol nájdený!",
  noParticipantEnrolled: "Nie sú prihlásení žiadni účastníci!",
  noDataToDisplay: "Nie sú žiadne údaje na zobrazenie",
  participantsPerPage: "Účastníci na stránku:",
  actionFailed: "Akcia zlyhala",
  failedToRemoveUser: "Používateľa sa nepodarilo odstrániť",
  bestScoreAcrossAttemptsInfo:
    "Označuje najlepšie skóre dosiahnuté pri viacerých pokusoch.",
  successfullyRemovedUser: "Používateľ bol úspešne odstránený",
  successfullyReinvitedUser: "Používateľ bol úspešne znova pozvaný",
  reinviteTooltip:
    "Znova pozvite účastníkov, ktorí ešte nezačali s priebežným hodnotením",
  reInvite: "Znova pozvať",
  noParticipantsInvitedYet: "Zatiaľ neboli pozvaní žiadni účastníci",
  scheduleExpired: "Platnosť plánu vypršala",
  assessmentIsOngoing: "Posudzovanie prebieha",
  assessmentCompleted: "Hodnotenie dokončené",
  resultNotProcessed: "Výsledok nespracovaný",
  assessmentNotStarted: "Hodnotenie sa nezačalo",
  remove: "Odstrániť",
  confirmReInvitation: "Potvrďte opätovné pozvanie",
  confirmReinviteMessage:
    "Naozaj chcete znova pozvať účastníkov, ktorí ešte nezačali prebiehajúce hodnotenie?",
  removeUserWithNamePrompt: "Naozaj chcete odstrániť „{{name}}“?",
  groupType: "Typ skupiny",
  objectiveGroupType: "Cieľ",
  codingGroupType: "Kódovanie",
  subjectiveTextSpeakingGroupType: "Subjektívne (text/hovorené slovo)",
  groupTypeImmutableInfo:
    "Typ skupiny nie je možné neskôr zmeniť. Pridávať možno iba otázky tohto typu.",
  sameMarkGroupingTitle:
    "Otázky možno zoskupovať iba vtedy, ak majú rovnakú hodnotu známky",
  sameMarkGroupingDescription:
    "Miešanie hodnôt známok (napr. 2-bodové a 5-bodové) v skupine môže viesť k rôznym bodovým hodnoteniam sekcií, keď sú vybraté len niektoré otázky. Zoskupte otázky s podobnými známkami, aby skóre zostalo konzistentné.",
  searchQuestion: "Vyhľadávacia otázka",
  addAllSelectedQuestions: "Pridajte všetky {{count}} vybraté otázky",
  singleQuestionSelectedCount: "Vybraná {{count}} otázka",
  allQuestionsSelectedCount: "Vybraných všetkých {{count}} otázok",
  selectedCountOfTotalQuestions: "Vybraných {{selected}} z {{total}} {{label}}",
  addSelectedQuestion: "Pridajte vybranú otázku",
  validationErrors: "Chyby overenia",
  failedToAddToGroup: "Pridanie do skupiny zlyhalo",
  questionsAddedSuccessfullyWithCount: "Úspešne pridané otázky: {{count}}",
  successfullyUpdatedAssessment: "Hodnotenie bolo úspešne aktualizované",
  editCustomTnc: "Upraviť vlastné zmluvné podmienky",
  addCustomTnc: "Pridať vlastné zmluvné podmienky",
  attributes: "Atribúty",
  added: "Pridané",
  addAttributes: "Pridať atribúty",
  clickHereToAddEditAttributes: "Kliknutím sem pridáte alebo upravíte atribúty",
  clickHereToAddAttributes: "Kliknutím sem pridáte atribúty",
  addTncAndSave: "Pridať zmluvné podmienky a uložiť",
  savedWithFollowingErrors: "Uložené s nasledujúcimi chybami",
  selectDomain: "Vybrať doménu",
  selectRegion: "Vybrať región",
  selectUsage: "Vybrať použitie",
  selectCategoryFirst: "Najprv vyberte kategóriu",
  selectSubCategory: "Vybrať podkategóriu",
  addAttributesAndSave: "Pridať atribúty a uložiť",
  questionPaperTimer: "Časovač testu",
  sectionLevelTimer: "Časovač na úrovni sekcie",
  questionLevelTimer: "Časovač na úrovni otázky",
  loginWindowDescription:
    "Kandidáti sa môžu pripojiť iba v obmedzenom časovom okne po čase začiatku.",
  durationBasedDescription:
    "Čas ukončenia sa automaticky vypočíta z času začiatku + trvania testu.",
  deadlineDescription:
    "Pevný čas začiatku a konca; kandidáti musia skončiť pred termínom.",
  loginWindowInfo:
    "Okno na prihlásenie je čas (v minútach), počas ktorého môžu kandidáti spustiť test po plánovanom čase začiatku. Po zatvorení okna na prihlásenie nemôže vstúpiť žiadny nový kandidát. Okno na prihlásenie musí byť kratšie alebo rovné trvaniu testu.",
  assessmentDurationInfo:
    "Nastavte iba čas začiatku. Systém automaticky vypočíta čas konca pripočítaním trvania testu.",
  startTimeMinAheadInfo:
    "Čas začiatku musí byť najmenej 15 minut vopred oproti aktuálnemu času.",
  loginWindowExample:
    "Príklad: Ak je čas začiatku 9:00 a okno na prihlásenie je 30 minút, kandidáti môžu začať medzi 9:00 a 9:30 s dodatočnou 5-minútovou rezervou.",
  assessmentDurationExample:
    "Príklad: Ak je čas začiatku 9:00 a trvanie testu je 60 minút, test skončí o 10:00 s dodatočnou 5-minútovou rezervou.",
  freeFlow: "Voľný prechod",
  oneByOne: "Po jednom",
  subjectiveNoResultInfo: "Subjektívne informácie k statusu 'Bez výsledku'",
  candidateResultVisibility: "Viditeľnosť výsledkov pre kandidáta",
  noResult: "Bez výsledku",
  passPercentageRangeError: "Chyba rozsahu percent pre úspešné absolvovanie",
  attemptsAllowedInfo: "Informácie o povolených pokusoch",
  maxAttemptsError: "Chyba: Prekročený maximálny počet pokusov",
  maximumAttemptsInfo: "Informácie o maximálnom počte pokusoch",
  limitedAttempts: "Obmedzený počet pokusov",
  coolOffDescription: "Popis doby na ochladenie (čakacej doby)",
  noCoolOffPeriod: "Bez čakacej doby",
  waitFor: "Počkať na",
  hours: "Hodiny",
  days: "Dni",
  whatLearnersWillSee: "Čo uvidia študenti",
  unlimitedAttemptsInfo:
    "Pre tento test máte k dispozícii neobmedzený počet pokusov.",
  waitBeforeNextAttemptPrefix: "Po každom pokuse budete musieť počkať",
  waitBeforeNextAttemptSuffix: "pred začatím ďalšieho pokusu.",
  waitBeforeNextAttempt:
    "Po každom pokuse budete musieť počkať {duration} pred začatím ďalšieho pokusu.",
  singleAttemptInfo: "Pre toto hodnotenie máte k dispozícii 1 pokus.",
  remainingAttemptsInfoPrefix: "Máte",
  remainingAttemptsInfoMiddle: "z",
  remainingAttemptsInfoSuffix: "pokusov k dispozícii pre toto hodnotenie.",
  remainingAttemptsInfo:
    "Máte {remaining} z {total} pokusov k dispozícii pre toto hodnotenie.",
  enableCertificate: "Povoliť certifikát",
  enableCertificateDescription:
    "Vydajte certifikát kandidátom po úspešnom dokončení hodnotenia.",
  maxAllowed100: "Maximálne povolené 100",
  scheduleAssessment: "Naplánovať hodnotenie",
  privateAssessmentLabel: "Súkromné hodnotenie",
  publicAssessmentLabel: "Verejné hodnotenie",
  privateAssessmentDescription:
    "Toto hodnotenie je dostupné iba na pozvánku a len v rámci definovaného časového okna začiatku a konca.",
  publicAssessmentDescription:
    "Toto hodnotenie podporuje samostatne priradený aj pozvánkový prístup bez pevného časového okna prístupu.",
  schedulePublicAssessment: "Naplánovať verejné hodnotenie",
  successfullyPublishedAssessment: "Hodnotenie bolo úspešne zverejnené",
  publishWithoutProctoringPrompt:
    "Zverejniť bez proctoringu (vzdialeného dohľadu)?",
  publishAssessmentPrompt: "Zverejniť hodnotenie?",
  sectionScoreAnalysis: "Analýza skóre sekcie",
  sectionScoreAnalysisOverview: "Prehľad analýzy skóre sekcie",
  section: "Sekcia",
  noSectionDataAvailable: "Pre túto sekciu nie sú dostupné žiadne údaje",
  difficultyLevelAnalysis: "Analýza úrovne náročnosti",
  browserViolations: "Porušenia pravidiel prehliadača",
  videoViolations: "Porušenia videozáznamu",
  times: "Krát",
  statusMessageUnavailable: "Stavová správa nedostupná",
  viewViolationEvidence: "Zobraziť dôkazy o porušení",
  noBrowserViolationsDetected:
    "Neboli zistené žiadne porušenia pravidiel prehliadača",
  noVideoViolationsDetected: "Neboli zistené žiadne porušenia videozáznamu",
  candidateNotAttemptedCodingMessage:
    "Správa: Kandidát sa nepokúsil o kódovanie",
  candidateCode: "Kód kandidáta",
  candidateScore: "Skóre kandidáta",
  compilationCount: "Počet kompilácií",
  submissionCount: "Počet odovzdaní",
  timeTaken: "Ubehnutý čas",
  testCaseReport: "Správa o testovacích prípadoch",
  performanceAndCompilationMetrics: "Metriky výkonu a kompilácie",
  totalTestCases: "Celkový počet testovacích prípadov",
  testCasesPassed: "Úspešné testovacie prípady",
  testCaseDetails: "Podrobnosti testovacieho prípadu",
  searchQuestions: "Hľadať otázky",
  clearSearch: "Vymazať vyhľadávanie",
  question: "otázka",
  isSelected: "je vybratá",
  areSelected: "sú vybraté",
  selected: "Vybraté",
  questionsPerPage: "Otázok na stránku:",
  publishQuestions: "Publikovať otázky",
  send: "Odoslať",
  move: "Presunúť",
  publishQuestionsConfirmation: "Naozaj chcete publikovať {{count}} {{label}}?",
  sendForReviewConfirmation:
    "Naozaj chcete odoslať {{count}} {{label}} na kontrolu?",
  moveToDraftConfirmation:
    "Naozaj chcete presunúť {{count}} {{label}} do konceptov?",
  bulkPublishDisclaimer:
    "Pred publikovaním skontrolujte, či sú všetky vybraté otázky úplné, správne a zobrazujú sa podľa očakávania.",
  bulkReviewDisclaimer:
    "Pred odoslaním na kontrolu skontrolujte, či sú všetky vybraté otázky úplné, správne a zobrazujú sa podľa očakávania.",
  bulkDraftDisclaimer:
    "Pred presunutím do konceptov skontrolujte, či sú všetky vybraté otázky úplné, správne a zobrazujú sa podľa očakávania.",
  questionsUnderProcess:
    "Otázky sa spracovávajú, pre kontrolu ich stavu kliknite na 'zobraziť podrobnosti'.",
  mixedStatusesSelected: "Vybraté zmiešané stavy",
  mixedStatusesWarning:
    "Pred pokračovaním sa uistite, že všetky vybraté otázky majú rovnaký stav.",
  selectionLimitReached: "Dosiahnutý limit výberu",
  selectionLimitWarning:
    "Pre hromadnú akciu nemôžete vybrať viac ako {{count}} otázok. Pred výberom inej otázky zrušte výber niektorej z aktuálnych.",
  knowMore: "Zistiť viac",
  guideLearnersRightDepth:
    "Veďte svojich študentov otázkami, ktoré zodpovedajú správnej hĺbke.",
  bloomCreateDescription:
    "Posúďte schopnosť študenta navrhovať, architektovať alebo vytvárať nové systémy alebo kódové riešenia s využitím viacerých konceptov.",
  bloomEvaluateDescription:
    "Skontrolujte, či študent dokáže kriticky posúdiť kód, zdôvodniť rozhodnutia alebo vyhodnotiť rôzne riešenia.",
  bloomAnalyzeDescription:
    "Otestujte schopnosť študenta rozobrať kód, ladit (debugovať), sledovať logiku alebo identifikovať vzory v technických systémoch.",
  bloomApplyDescription:
    "Vyhodnoťte, či študent dokáže aplikovať koncepty na riešenie praktických problémov s kódovaním alebo scenárov z reálneho sveta.",
  bloomUnderstandDescription:
    "Skontrolujte, či študent dokáže pochopiť a vysvetliť koncepty vlastnými slovami alebo interpretovať správanie programu.",
  bloomRememberDescription:
    "Posúďte schopnosť študenta vybaviť si základné definície, syntax a faktické informácie.",
  bloomVerbCreate: "Vytvoriť",
  bloomVerbDesign: "Navrhnúť",
  bloomVerbConstruct: "Konštruovať",
  bloomVerbDevelop: "Vyvinúť",
  bloomVerbEvaluate: "Vyhodnotiť",
  bloomVerbJustify: "Zdôvodniť",
  bloomVerbDefend: "Obhájiť",
  bloomVerbAssess: "Posúdiť",
  bloomVerbAnalyze: "Analyzovať",
  bloomVerbDifferentiate: "Rozlíšiť",
  bloomVerbOrganize: "Usporiadať",
  bloomVerbCompare: "Porovnať",
  bloomVerbApply: "Aplikovať",
  bloomVerbUse: "Použiť",
  bloomVerbDemonstrate: "Demonštrovať",
  bloomVerbSolve: "Vyriešiť",
  bloomVerbExplain: "Vysvetliť",
  bloomVerbDescribe: "Opísať",
  bloomVerbSummarize: "Zhrnúť",
  bloomVerbInterpret: "Interpretovať",
  bloomVerbList: "Uviesť",
  bloomVerbDefine: "Definovať",
  bloomVerbName: "Pomenovať",
  bloomVerbRecall: "Spomenúť si",
  bloomVerbRecognize: "Rozpoznať",
  bloomCreateExample1:
    "Vytvorte jednostránkovú aplikáciu (SPA) pomocou React a Redux.",
  bloomCreateExample2:
    "Navrhnite schému databázy pre aplikáciu na zdieľanú jazdu (ride-sharing).",
  bloomCreateExample3: "Vyviňte CI/CD pipeline pomocou GitHub Actions.",
  bloomEvaluateExample1:
    "Vyhodnoťte výhody a nevýhody použitia NoSQL oproti SQL v architektúre mikro služieb.",
  bloomEvaluateExample2:
    "Odporučte vylepšenia na optimalizáciu výkonu tohto React komponentu.",
  bloomAnalyzeExample1: "Porovnajte výkon algoritmov merge sort a quicksort.",
  bloomAnalyzeExample2: "Analyzujte využitie pamäte tejto rekurzívnej funkcie.",
  bloomAnalyzeExample3: "Kategorizujte chyby v tomto bloku JavaScript kódu.",
  bloomApplyExample1:
    "Aplikujte algoritmus binárneho vyhľadávania na nájdenie prvku v poli.",
  bloomApplyExample2:
    "Použite cyklus na vykreslenie Fibonacciho postupnosti v Pythone.",
  bloomApplyExample3: "Vyriešte reálny problém pomocou hash mapy.",
  bloomUnderstandExample1:
    "Vysvetlite, ako funguje zásobník (stack) pomocou princípu LIFO.",
  bloomUnderstandExample2:
    "Opíšte rozdiel medzi var, let a const v JavaScripte.",
  bloomUnderstandExample3: "Interpretujte výstup zadaného SQL dopytu.",
  bloomRememberExample1:
    "Identifikujte správny HTML tag na vytvorenie hypertextového odkazu.",
  bloomRememberExample2:
    "Pomenujte štyri piliere objektovo orientovaného programovania (OOP).",
  bloomRememberExample3: "Uveďte primitívne dátové typy v Jave.",
  commonVerbs: "Bežné slovesá",
  exampleQuestions: "Príklady otázok",
  noExamplesAvailable: "Nie sú dostupné žiadne príklady.",
  candidateResponse: "Odpoveď kandidáta",
  correctQuestions: "Správne otázky",
  totalQuestions: "Celkový počet otázok",
  correctQuestionPercentage: "Percento správnych otázok",
  performance: "Výkon",
  level: "ÚROVEŇ",
  noOfQuestions: "POČET OTÁZOK",
  correctAttempts: "SPRÁVNE POKUSY",
  correctness: "SPRÁVNOSŤ",
  partiallyCorrect: "ČIASTOČNE SPRÁVNE",
  partiallyCorrectPercentage: "PERCENTO ČIASTOČNE SPRÁVNYCH",
  rescheduleAssessmentPrompt:
    "Potvrďte, či chcete zmeniť termín testu s názvom „{{title}}“",
  assessmentAlreadyStarted: "Test už začal",
  readMore: "Čítať viac",
  best: "Najlepšie",
  latest: "Najnovšie",
  allQuestions: "Všetky otázky",
  myQuestions: "Moje otázky",
  publicQuestions: "Verejné otázky",
  remarks: "Poznámky",
  addRemarks: "Pridať poznámky",
  noGroupsAdded: "Zatiaľ neboli pridané žiadne skupiny",
  addGroupInfo:
    "Najskôr vytvorte skupinu, aby ste mohli začať pridávať otázky. Kliknutím na tlačidlo „Pridať skupinu do sekcie“ nižšie začnite.",
  exitPreview: "Ukončiť náhľad",
  preview: "Náhľad",
  problemStatementNotAdded: "Problémový výrok nebol pridaný",
  durationDayUnit: "deň",
  durationDaysUnit: "dni",
  durationHourUnit: "hod.",
  durationHoursUnit: "hod.",
  durationMinuteUnit: "min",
  customFieldAddedForSingleLanguage:
    "Vlastné pole {{fieldLabel}} pridané pre {{current}} z {{total}} jazyka",
  customFieldAddedForMultipleLanguages:
    "Vlastné pole {{fieldLabel}} pridané pre {{current}} z {{total}} jazykov",
  email: "E-Mail",
  tagInputHint: "Pridať oddelené čiarkou",
  enterOptions: "Zadajte možnosti",
  groupNotFound: "Skupina nebola nájdená",
  sheetNotFound: "Hárok nebol nájdený",
  missingHeaders: "Chýbajú požadované hlavičky",
  assetNotFound: "Aktívum nebolo nájdené",
  noValidDataFound: "Nenašli sa žiadne platné údaje",
  notFoundPID: "Účastník nebol nájdený.",
  invalidParticipants: "Neplatný účastník.",
  alreadyAdded: "Účastník už bol pridaný.",
  duplicateData: "Nájdené duplicitné údaje.",
  invalidData: "Neplatné údaje.",
  warnings: "Upozornenia",
  assignedToMyself: "Pridelené mne (Samostatné učenie)",
  assignedByMe: "Pridelené mnou (Moje Úlohy)",
  urlCopiedToClipboard: "URL skopírovaný do schránky!",
  failedToCopyUrl: "Chyba pri kopírovaní URL.",
  content: "Obsah",
  platformHelp: "Pomoc platformy",
  privacyPolicy: "Zásady ochrany osobných údajov",
  logout: "Odhlásiť sa",
  logoutConfirmTitle: "Naozaj sa chcete odhlásiť?",
  logoutConfirmDescription:
    "Odchádzate? Kedykoľvek sa môžete vrátiť a pokračovať tam, kde ste skončili.",
  stayEngaged: "Zostať zapojený"
} as const;
export default sk;
